import { useEffect } from 'react';

import FeaturedProjects from '../../components/FeaturedProjects';
import ProjectsExplorer from '../../components/ProjectsExplorer';
import SectionHead from '../../components/SectionHead';
import { useFilters } from '../../hooks/projectFilters';

import Container from './styles';

const Projects = () => {
  const { searchString } = useFilters();

  useEffect(() => {
    document.title = 'Projetos | Portal Due It';
  }, []);

  return (
    <Container>
      <SectionHead
        title={searchString ? `Resultados para "${searchString}"` : 'Projetos'}
        description="Projetos gratuitos e pagos, filtrados por categoria, material ou preço."
      />
      <ProjectsExplorer />
      <FeaturedProjects title="Projetos destaque" />
    </Container>
  );
};

export default Projects;
